// import { EmailClientComponent } from './../../marketing/common/components/email-client/email-client.component';
import { concatMap, toArray, catchError } from 'rxjs/operators';
import {
  Component,
  OnInit,
  OnChanges, 
  SimpleChanges,
  ViewChild,
  AfterContentInit,
  Inject
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { from, of, pipe, Subscription } from "rxjs";
import { Subject } from "rxjs/internal/Subject";
import { filter, map, takeUntil, mergeMap, first, take, pluck } from 'rxjs/operators';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EmailClientService } from "../service/email-client.service";
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { InteractionStatus, InteractionType } from '@azure/msal-browser';
import { OutlookEmailClientTableComponent } from "../outlook-email-client-table/outlook-email-client-table.component";
import { GoogleApiService, UserInfo } from "../../scheduling/google-api.service";
import { ToastrService } from 'ngx-toastr';
import {environment} from '../../../../environments/environment';

interface emailAccount {
  name: string,
  code: string
}

@Component({
  selector: "app-email-client",
  templateUrl: "./email-client.component.html",
  styleUrls: ["./email-client.component.scss"],
})
export class EmailClientComponent implements OnInit, OnChanges, AfterContentInit {

  tabArray: any = [{name: 'IMAGILITY EMAIL', value: true}, {name: 'CONNECT GMAIL', value: false}, {name: 'CONNECT OUTLOOK', value: false}]


  compose_gmail:boolean = false;
  emailAccounts: emailAccount[];
  selectedEmailAccount: emailAccount;
  @ViewChild(OutlookEmailClientTableComponent, { static: true }) child: OutlookEmailClientTableComponent;
  newEmail: string = "New Mail";
  toggleStatus: string = "";
  emailType = "Inbox";
  apiData!: any;
  loginDisplay: boolean = false;
  isIframe: boolean = false;
  readonly _destroying$ = new Subject<void>();
  isEmailClientTable: boolean = true;
  profile: any;
  selectedLbls: any;
  headerActionType: any = "From";
  emailClientTableList: any;
  readEmail: boolean = false;
  emailMessageCount: number = 0;
  emailId: string = '';
  subjectId: string;
  selRow: any;
  skipItems: number = 0;
  topItems: number = 5;
  gmailmaxResult: number = 5;
  userInfo: UserInfo;
  emailSub: Subscription;
  folderSub: Subscription;
  observableSubscription$ = new Subject();
  selAccountType: string = 'outlook';
  nextPageToken: string = '';
  outlookMessageType: string;
  paginationTokenArr: Array<string> = [];
  isDisableObject = { prev: false, next: false };
  isNextButton: boolean = false;
  isPrevButton: boolean = false;
  isScheduling: boolean = false;
  displayName: string = '';
  changeFolderType: boolean;
  labelPickModal: boolean = false;
  allFolders: any;
  labelDropdownList: any[];
  MenuLabelDropdownList: any[];
  gmailLabelDropdownList: any[];
  isLoadingRecords: boolean = false;
  googleSettingsMenu: any;
  clonnedselectedGoogleCals: any;
  outlookSettingsMenu: any;
  isGcallogoutInProgress: boolean;
  userType: string;
  navUrl: string;
  currentGmailCompany:Number;
  gmailCompanyList: any = environment.gmailCompany;
  isGmailCompany:boolean = true;



  constructor(public authService: MsalService,
    private ngxService: NgxUiLoaderService,
    private readonly googleApi: GoogleApiService,
    private toastr: ToastrService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private router: Router,
    public emailClientService: EmailClientService) {
    this.userType = sessionStorage.getItem("userTypeRole");
    if (this.userType == "Petitioner") {
      this.navUrl = "/petitioner-landing/dashboard/petitioner-dashboard/";
    } else if (this.userType == "Attorney") {
      this.navUrl = "/attorney-landing/dashboard/attorney-dashboard/";
    }
    this.googleApi.userProfileSubject.subscribe((info: any) => {
      this.initGmail(info)
    })
    this.emailAccounts = [
      { name: 'Outlook', code: 'outlook' },
      // { name: 'Gmail', code: 'gmail' }
    ];
    this.selectedEmailAccount = this.emailAccounts[0];
  }

  initGmail(info) {
    this.userInfo = info;
    localStorage.setItem('userInfo', JSON.stringify(info));
    this.selAccountType = 'outlook';
    this.selectedEmailAccount = { name: 'Outlook', code: 'outlook' }
    this.initGoogleSettingsMenu();
    this.getMails();
    this.getAllFoldersGmail();
  }

  composeEmail(){
    this.compose_gmail = true;
  }

  ngOnInit(): void {    
    // document.getElementById("wooow").innerHTML = 'Please Login To Sync With GMAIL';
    document.getElementById("gmailMainContainer").style.visibility = "hidden";
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    let isGmailLoggedIn = userInfo !== null;
    if (isGmailLoggedIn) {
      this.initGmail(userInfo);
    }
    this.setLoginDisplay();
    this.onSelectedChange("Inbox");
    this.emailClientService.folderChangeSubject$.subscribe(folderchange => {
      if (folderchange) {
        let label = '';
        if (this.selAccountType == 'outlook') {
          label = this.emailClientService.outlookMessageType ? this.emailClientService.outlookMessageType : 'Inbox';
          label = label == "compose-mail" ? 'Inbox' : label;
        }
        else if (this.selAccountType == 'gmail') {
          label = this.googleApi.googleMessageType ? this.googleApi.googleMessageType : 'INBOX';
          // label = label=="compose-mail" ? 'INBOX' : label;
        }
        this.changeFolderType = folderchange;
        this.emailClientService.isPaginationDisplay = true;
        this.onSelectedChange(label);
        this.getAllFolders();
      }
    })

    this.emailSub = this.emailClientService.emailDetailSubscription$.subscribe(data => {
      this.readEmail = data['read'];
      this.emailType = data['emailType'];
      if (this.emailType) {
        this.onSelectedChange(this.emailType);
      }
    });

    if (this.router.url.includes('scheduling')) {
      this.isScheduling = true;
    }
    else if (this.router.url.includes('/attorney-landing/dashboard/attorney-dashboard/email-client')) {
      this.isScheduling = false;
    }
    this.getAllFolders();
  }

  loginOutlook() {
    this.emailClientService.loginOutlook();
  }

  ngAfterContentInit(): void {
    // if (!this.authService.instance.getAllAccounts().length) {
    // this.emailClientService.loginOutlook();
    // setTimeout(()=>{
    //   this.getAllFolders();
    //   },100)
    // }
  }

  initGoogleSettingsMenu() {
    this.googleSettingsMenu = [
      {
        label: "Google Settings",
        items: [
          {
            label: "Remove Account",
            icon: "pi pi-times",
            command: () => {
              localStorage.removeItem("selectedGoogleCalendars");
              this.logoutGoogle();
            },
          },
        ],
      },
    ];
  }


  logoutGoogle() {
    // this.googleApi.signOut()
    this.isGcallogoutInProgress = true;
    let localStorageElems = [
      "userInfo",
      "nonce",
      "access_token_stored_at",
      "access_token",
      "PKCE_verifier",
      "id_token_claims_obj",
      "session_state",
      "granted_scopes",
      "refresh_token",
      "expires_at",
      "id_token_expires_at",
      "selectedGoogleCalendars",
      "id_token_stored_at",
      "id_token",
      "session_end",
    ];
    localStorageElems.forEach((k) => localStorage.removeItem(k));
    this.userInfo = null;
    setTimeout(() => {
      this.isGcallogoutInProgress = false;
      window.location.reload();
    }, 2000);
  }

  initOutlookSettingsMenu() {
    this.outlookSettingsMenu = [
      {
        label: "Outlook Settings",
        items: [
          {
            label: "Remove Account",
            icon: "pi pi-times",
            command: () => {
              sessionStorage.removeItem("selectedOutlookCalendars");
              this.logoutOutlook();
            },
          },
        ],
      },
    ];
  }

  logoutOutlook() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri:
          "/attorney-landing/dashboard/attorney-dashboard/scheduling",
      });
    } else {
      this.authService.logoutRedirect({
        postLogoutRedirectUri:
          "/attorney-landing/dashboard/attorney-dashboard/scheduling",
      });
    }
  }

  async getAllFolders() {
    await this.emailClientService.getFolders().toPromise().then(allFolders => {
      this.allFolders = allFolders;
      // this.onSelectedChange("Inbox");
      this.labelDropdownList = allFolders['value'].filter((folder: any) => {
        return folder.displayName.includes("IM-");
      });
      this.MenuLabelDropdownList = this.labelDropdownList.filter((folder: any) => {
        return folder.isHidden === false;
      });
    });
  }

  async getAllFoldersGmail() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const userId = userInfo.info.email;
    try {
      await this.googleApi.getFolders(userId).toPromise().then(allFolders => {
        this.allFolders = allFolders;
        this.onSelectedChange("Inbox");
        this.gmailLabelDropdownList = allFolders['labels'].filter((folder: any) => {
          return folder.name.includes("IM-");
        });
        // sort label on asending order.
        this.gmailLabelDropdownList = this.gmailLabelDropdownList?.sort((a, b) => a.name.localeCompare(b.name))

      }).catch(error => {
        if (error.error.error.status === "UNAUTHENTICATED") {
          this.googleApi.login().then(() => { });
        }
      });
    } catch (error) {
      if (error.error.error.status === "UNAUTHENTICATED") {
        this.googleApi.login().then(() => { });
      }
    }
  }

  selectedGoogleCalendars(choosedLabelIds) {
    this.labelPickModal = false;
    // let existingEvSources = this.userCalendar.getApi().getEventSources().filter(x => x.id.includes('google'));
    // existingEvSources.forEach(source => {
    //   let eventSource = this.userCalendar.getApi().getEventSourceById(source.id);
    //   eventSource !== null ? eventSource.remove() : '';
    // })
    // localStorage.setItem("selectedGoogleCalendars", JSON.stringify(choosedCalIds));
    // choosedCalIds.forEach(calId => this.getGoogleCalEvents(calId));
  }

  onAccountChange(event) {
    if (event) {
      this.selRow = undefined;
      this.emailClientTableList = [];
      this.labelDropdownList = [];
      this.MenuLabelDropdownList = [];
      this.gmailLabelDropdownList = [];
      if (event.value.code === 'gmail') {
        // this.emailClientService.accountType=event.value.code;
        this.googleApi.getUserProfile().then(res => {
          this.emailClientService.selectedEmailAccount = event.value.code;
          this.selAccountType = this.emailClientService.selectedEmailAccount;
          if (!this.userInfo) {
            this.googleApi.login().then(() => {
              this.getMails();
              this.getAllFoldersGmail();
            })
          } else {
            this.getMails();
            this.getAllFoldersGmail();
          }
        });
      } else if (event.value.code === 'outlook') {
        this.emailClientService.selectedEmailAccount = event.value.code;
        this.selAccountType = this.emailClientService.selectedEmailAccount;
        if (!this.authService.instance.getAllAccounts().length) {
          this.emailClientService.loginOutlook();
        } else {
          this.getAllFolders();
          this.emailClientService.selectedUsername = this.authService.instance.getAllAccounts()[0]?.username;
          this.getMailFoldersEmail(this.emailType, this.skipItems, this.topItems);
        }

        this.isIframe = window !== window.parent && !window.opener;
        this.emailClientService.getInProgress()
          .pipe(
            filter((status: InteractionStatus) => status === InteractionStatus.None),
            takeUntil(this._destroying$)
          )
          .subscribe(() => {
            this.setLoginDisplay();
          })
        this.emailClientService.getInProgress()
          .pipe(
            filter((status: InteractionStatus) => status === InteractionStatus.None),
            takeUntil(this._destroying$)
          )
          .subscribe(() => {
            this.setLoginDisplay();
          })
      }
    }
  }


  async getMails() {
    this.isLoadingRecords = true;
    if (!this.userInfo) {
      this.isLoadingRecords = false;
      return;
    }
    const label = this.googleApi.googleMessageType ? this.googleApi.googleMessageType : 'INBOX';
    const email = this.userInfo.info.email;
    this.googleApi.selectedUsername = email;
    this.subjectId = '3126IMAGILITY';
    try {
      this.googleApi.getGmailThreads(label, email, this.subjectId, this.gmailmaxResult, this.nextPageToken).pipe(
        // pluck('messages'),
        map((result: Array<any>) => {
          let data = [];
          result['threads']?.forEach(element => {
            data.push(element.id);
          });
          this.nextPageToken = result['nextPageToken'];
          return data;
        }),
        catchError((err, caught) => {
          return of([]);
        })
      ).pipe(catchError(error => of(`Bad Promise: ${error}`))).subscribe(data => {
        this.changeFolderType = false;
        this.emailClientService.isPaginationDisplay = true;
        from(data).pipe(concatMap((threadId: string) => {
          if (threadId) {
            return this.googleApi.getGmailThreadOnId(threadId, email, label);
          }
          else {
            of([]);
          }
        }), toArray())
          .subscribe((data: any) => {
            this.isLoadingRecords = false;
            if (data && data.length) {

              let emailArr = []
              this.setPaginationDisable(false, false);
              data.forEach((eData: any) => {
                let x = eData.messages[0];
                const filerMsg = x.payload.headers.filter(header => header.name == "From" || header.name == "To" ||
                  header.name == "CC" || header.name == "Subject" || header.name == "Date" || header.name == "Importance");
                const emailObject = filerMsg.reduce(
                  (obj, item) => Object.assign(obj, { [item.name]: item.value }), {});
                //get attachments
                const attachmentArr = [];
                x?.payload?.parts?.forEach(part => {
                  if (part.filename) {
                    attachmentArr.push(part?.body?.attachmentId);
                  }
                })
                let unReadMsg = false;
                for (let msg of eData?.messages) {
                  unReadMsg = msg.labelIds.includes('UNREAD') ? true : false;
                  if (unReadMsg) {
                    break;
                  }
                }

                emailArr.push({ ...emailObject, id: x.id, threadId: x.threadId, attachmentId: attachmentArr, labelIds: x.labelIds, unReadMsg: unReadMsg });
                this.emailClientTableList = emailArr;
              })
            }
            else if (this.isNextButton) {
              this.setPaginationDisable(true, false);
            }
            else if (this.isPrevButton) {
              this.setPaginationDisable(false, true);
            } else {
              this.emailClientTableList = [];
            }
          })
      })
    } catch (error) {
      this.isLoadingRecords = true;
      if (error.error.error.status === "UNAUTHENTICATED") {
        this.googleApi.login().then(() => { });
      }
    }
  }

  deleteOutLookEmails() {
    this.child.deleteOutLookEmails();
  }

  changeFolder(event: any) {
    this.onSelectedChange(this.emailType);
  }

  labelAdded(event: any) {
    this.getAllFolders();
  }

  gmailLabelAdded(event: any) {
    this.getAllFoldersGmail();
  }


  onPaginationChange(paginateData: any) {
    this.skipItems = paginateData.skipItems;
    this.topItems = paginateData.topItems;
    this.getMailFoldersEmail(this.emailType, this.skipItems, this.topItems);
  }

  onGmailPaginationChange(paginateData: any) {
    if (paginateData == 'next') {
      this.isNextButton = true;
      if (this.paginationTokenArr.indexOf(this.nextPageToken) < 0 && this.nextPageToken) {
        this.paginationTokenArr.push(this.nextPageToken);
        this.getMails();
      }
      else {
        this.setPaginationDisable(true, false);
      }
    }
    else {
      this.isPrevButton = true;
      if (this.paginationTokenArr && this.paginationTokenArr.length) {
        this.paginationTokenArr = this.paginationTokenArr.slice(0, -1);
        this.nextPageToken = this.paginationTokenArr[this.paginationTokenArr.length - 1];
        this.getMails();
      }
      else {
        this.setPaginationDisable(false, true);
      }
    }
  }

  setPaginationDisable(prev, next) {
    this.isDisableObject.next = next;
    this.isDisableObject.prev = prev;
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this.observableSubscription$.unsubscribe();
    this._destroying$.complete();
  }

  onEventType(event: string[]) {
    this.onSelectedChange(event);
  }

  onSelectedChange(selectedEmailType) {
    // this.emailClientService.totalrecords
    // this.changeFolderType = true;
    this.emailClientService.isPaginationDisplay = false;
    this.skipItems = 0;
    this.topItems = 5;
    this.emailClientTableList = [];
    this.paginationTokenArr = [];
    this.nextPageToken = '';
    this.readEmail = false;
    this.toggleStatus = selectedEmailType;
    this.emailType = selectedEmailType;
    this.emailClientService.outlookMessageType = selectedEmailType;
    this.outlookMessageType = this.emailClientService.outlookMessageType;
    // this.emailClientService.emailDetailSubscription$.next({ read: false, emailType: this.emailType });
    if (this.emailType === "Sent Items" || this.emailType === "Drafts" || this.emailType === "Deleted Items") {
      this.headerActionType = "To";
    }
    else if (this.emailType === "Inbox") {
      this.headerActionType = "From";
    }
    else if (this.emailType === "compose-mail") {
      this.newEmail = "Compose Email";
      this.emailClientService.selectedReplyType = '';
      this.googleApi.selectedReplyType = '';
    } else {
      this.newEmail = "New Mail";
      this.emailClientService.selectedReplyType = '';
      this.googleApi.selectedReplyType = '';
    }

    if (this.userInfo && this.selAccountType === 'gmail') {
      this.setMailTypeForGoogle(selectedEmailType);
      this.getMails();
    }
    else if (this.selAccountType !== 'gmail') {
      this.emailClientService.selectedReplyType = '';
      this.ngxService.start();
      this.displayName = this.getUserName();
      this.emailClientService.selectedUsername = this.authService.instance.getAllAccounts()[0]?.username;
      this.emailClientService.selectedUsername = this.authService.instance.getAllAccounts()[0]?.username;
      this.getMailFoldersEmail(this.emailType, this.skipItems, this.topItems);
      this.isEmailClientTable = true;
      this.ngxService.stop();
    }

  }

  openLabelSetting() {
    this.labelPickModal = true;
  }

  selectedLabels(selectedLbls) {
    console.log(selectedLbls);
  }

  getUserName() {
    let firstname = JSON.parse(sessionStorage.currentUser).firstname ? JSON.parse(sessionStorage.currentUser).firstname : '';
    let lastname = JSON.parse(sessionStorage.currentUser).lastName ? JSON.parse(sessionStorage.currentUser).lastName : '';
    let fullname = firstname + ' ' + lastname;
    return fullname;
  }

  setMailTypeForGoogle(mailType: string) {
    if (!mailType.includes("Label_")) {
      let googleMessageType: string;
      switch (mailType) {
        case 'Sent Items':
          googleMessageType = 'SENT';
          break;
        case 'Drafts':
          googleMessageType = 'DRAFT';
          break;
        case 'Deleted Items':
          googleMessageType = 'TRASH';
          break;
        default:
          googleMessageType = 'INBOX';
      }
      this.googleApi.googleMessageType = googleMessageType;
    }
    else {
      this.googleApi.googleMessageType = mailType;
    }
  }
  selectedTableRowData(rowData: any) {
    this.emailId = rowData.id;
    // this.emailId= rowData.conversationId;
    this.selRow = rowData;
    this.emailType = null;
    this.readEmail = true;

  }
  deleteMail(data) {
    this.onSelectedChange(data);
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes, "changes????????????????");
  }
  addGoogleAccount() {
    this.googleApi.login().then(() => {
      this.getMails();
    })
  }

  backtoDashboard() {
    this.router.navigate([this.navUrl]);
  }

  setLoginDisplay() {
    let outlookAccounts = this.authService.instance.getAllAccounts();
    this.loginDisplay = outlookAccounts.length > 0;
    if (outlookAccounts.length > 0) {
      this.initOutlookSettingsMenu();
      this.emailClientService.getProfile().subscribe((res: any) => {
        
        this.profile = res;
        this.emailClientService.selectedUsername = this.authService.instance.getAllAccounts()[0]?.username;
        this.getMailFoldersEmail(this.emailType, this.skipItems, this.topItems);

      });
    }
  }
  getMailFoldersEmail(emailType: string, skipItems: number, topItems: number) {
    this.isLoadingRecords = true; //for display loading text while change the tabs
    if (emailType !== "compose-mail") {
      const select = "subject,sender,sentDateTime,toRecipients,from,conversationId,isRead,importance";
      this.emailClientService.getDraftMessages().pipe(
        map(allForders => allForders['value'].filter((specificFolder: any) => specificFolder.displayName === emailType)[0]['id']),
        mergeMap((response: any) => {
          if (response) {
            return this.emailClientService.getMessages(select,skipItems, topItems, emailType, response);
          }
          else {
            of([]);
          }
        })
      ).subscribe((messages: any) => {
        // this.changeFolderType = false;
        this.emailClientService.isPaginationDisplay = true;
        this.emailMessageCount = messages['@odata.count'];
        this.emailClientService.totalrecords = this.emailMessageCount
        this.emailClientTableList = messages.value;
        this.isLoadingRecords = false;
      },
        (error) => {
          this.isLoadingRecords = false;
        }
      );
    } else {
      this.isLoadingRecords = false;
    }
  }


  emailRouting(_data:any){
    
    for(var x =0; x <this.tabArray.length; x++){
      if(_data.name == this.tabArray[x].name){
        this.tabArray[x].value = true
      }
      else{
        this.tabArray[x].value = false
      }
    } 
  }
}